export { default } from "./SimpleMarkdown";
